import { S129gS129m01Component } from './s129g-s129m01.component';

export { S129gModule } from './s129g.module';

export const S129gSubComponentsMap = {
	
};

export const S129gComponentsMap = {
	"s129g-s129m01": S129gS129m01Component
};

export const S129gComponents = [
	S129gS129m01Component
];

